﻿module.exports = {
    bindings: {
        groups: '<'
    },
    templateUrl: 'good/components/measure-condition-buttons.html'
};
